import { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
}

const Card = ({ children, className }: CardProps) => {
  return (
    <div
      className={`divide-y divide-gray-200 overflow-show rounded-xl bg-white shadow-md w-full ${className}`}
    >
      {children}
    </div>
  );
};
export default Card;
